/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unlockConvo.defs.js'
export { main as default } from './unlockConvo.defs.js'
